import { Injectable } from '@angular/core';
import { BaseapiService } from '../configuration_service/baseapi.service';
import { ConfigurationService } from '../configuration_service/configuration.service';
import { ActionNames } from '../../enums/apiActionName.enum';
import { ResultModel } from '../../model/ResultModel';
import { MinBilConsentModel } from '../../model/MinBilConsentModel';
import { RegistrationModel } from '../../model/Registration.model';

@Injectable({
  providedIn: 'root'
})
export class DataCommunicationService {

  constructor(
    private baseService: BaseapiService,
    private config: ConfigurationService
  ) { }

  public getCustomerDetailByMobile(mobileNo: string) {
    const APIpath = ActionNames.EXTENRAINTERFACE + '/' + ActionNames.GETCUSTOMER + '/' + ActionNames.MOBILENUMBER + '/' + mobileNo;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), mobileNo);
  }

  public getDealerImage(DealerName: any){
    const APIpath = ActionNames.DEALERIMAGE;
    return this.baseService.Get<any>(this.config.createUrl(APIpath),DealerName);
  }

  public getDealerByDmsNo(DmsId: any){
    const APIpath = ActionNames.GETDEALERBYDMSID;
    return this.baseService.Get<any>(this.config.createUrl(APIpath),DmsId);
  }

  public getMobileOTP(mobileNo: string, dealername: string, appointmentSource: string) {
    const APIpath = ActionNames.SMS +
      '/' + ActionNames.SENDOTP +
      '/' + mobileNo +
      '/' + dealername +
      '/' + appointmentSource;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), mobileNo);
  }

  public verifyMobileOTP(otpForm: any) {
    const APIpath = ActionNames.SMS +
      '/' + ActionNames.VERIFYOTP;
    return this.baseService.Post<any>(this.config.createUrl(APIpath), otpForm);
  }

  public getCustomerVehicleList(mobileNo: string,dealerNo: number) {
    const APIpath = ActionNames.EXTENRAINTERFACE +
      '/' + ActionNames.GETCUSTOMERVEHICLELIST +
      '/' + ActionNames.MOBILENUMBER +
      '/' + mobileNo +
      '/' + dealerNo;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), mobileNo);
  }

  public getVehicleServiceList(param: any) {
    const APIpath = ActionNames.SERVICES;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), param);
  }
  public getAllPackages(formData: FormData) {

    const APIpath = ActionNames.PACKAGE;
    return this.baseService.Get<any>(this.config.createUrl(APIpath),formData);
  }
  public GetRecallDetail(formData: FormData) {

    const APIpath = ActionNames.RECALLDETAIL;
    return this.baseService.Get<any>(this.config.createUrl(APIpath),formData);
  }
  public getMPOAdditionalPackage(formData: FormData)
  {
    const APIpath = ActionNames.MPOADDITIONALSERVICE;
    return this.baseService.Get<any>(this.config.createUrl(APIpath),formData);
  }
  public getrentalCar(param: any) {
    const APIpath = ActionNames.RENTALCARS;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), param);
  }

  public getDealerList(param: any) {
    const APIpath = ActionNames.DEALERS;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), param);
  }

  public checkAppointmentAvability(param: any) {
    const APIpath = ActionNames.APPOINTMENT +
      '/' + ActionNames.CHECKAVABLITY;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), param);
  }

  public saveBookingOrder(param: any) {
    const APIpath = ActionNames.APPOINTMENT +
      '/' + ActionNames.ADD;
    return this.baseService.Post<any>(this.config.createUrl(APIpath), param);
  }

  public getDealerById(dealerId: any) {
    const APIpath = ActionNames.DEALERS;
    return this.baseService.GetById<any>(this.config.createUrl(APIpath),dealerId);
  }
  public getBrandById(Id: any) {
    const APIpath = ActionNames.BRAND;
    return this.baseService.GetById<any>(this.config.createUrl(APIpath),Id);
  }

  public getDealersConfigurationById(param: any) {
    const APIpath = ActionNames.DEALERCONFIGURATION;
    return this.baseService.GetById<any>(this.config.createUrl(APIpath), param + '?isForBo=false');
  }

  public getDealerBrands(dealerID:any)
  {
    const APIpath = ActionNames.DEALERS+'/'+dealerID+'/'+ActionNames.BRAND;
    return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public getDealerModels(dealerID:any)
  {
    const APIpath = ActionNames.DEALERS+'/'+dealerID+'/'+ActionNames.MODELS;
    return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public getAvailableMechanic(mechanicForm: any){
    const APIpath = ActionNames.APPOINTMENT+'/'+ActionNames.MECHANICSDATA;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), mechanicForm);
  }

  public getModelPDF(modelCode: string, brandCode: string){
    const APIpath = ActionNames.EXTENRAINTERFACE +'/' + ActionNames.GETMODELPDF+'/'+modelCode+'/'+brandCode;
    return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public getAllBrandModels(){
    const APIpath = ActionNames.BRANDMPDEL;
    return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public getAccessories(id: any){
    const APIpath = ActionNames.ACCESSORIES + '/' + ActionNames.GETACCESSORIES + '/'+id+'/'+true;
    return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public GetMySiteParams(id: any){
    const APIpath = ActionNames.CUSTOMERS + '/' + ActionNames.GETMYSITEPARAM + '/'+id;
    return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public GetGiftCardByPhone(phone: string){
    const APIpath = ActionNames.CUSTOMERS + '/' + ActionNames.GETGIFTCARDBYPHONE + '/'+phone + '/' + false;
    return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public GetMinBilConsent(phone: string){
    const APIpath = ActionNames.CUSTOMERS + '/' + ActionNames.GETMINBILCONSNET + '/'+phone;
    return this.baseService.GetAll<ResultModel<MinBilConsentModel>>(this.config.createUrl(APIpath));
  }

  public UpdateMinBilConsent(param: MinBilConsentModel) {
    const APIpath = ActionNames.CUSTOMERS + '/' + ActionNames.UPDATEMINBILCONSNET;
    return this.baseService.Post<boolean>(this.config.createUrl(APIpath), param);
  }
  public GetUpSellData(brand: string){
      const APIpath = ActionNames.GETUPSELLDATABYBRAND + '/' + brand;
      return this.baseService.GetAll<any>(this.config.createUrl(APIpath));
  }

  public SendRegistrationEmail(param: RegistrationModel){
    const APIpath = ActionNames.CUSTOMERS + '/' + ActionNames.SENDREGISTRATIONEMAIL;
    return this.baseService.Post<boolean>(this.config.createUrl(APIpath), param);
  }
  public getAvailableSplitMechanic(mechanicForm: any){
    const APIpath = ActionNames.APPOINTMENT+'/'+ActionNames.MECHANICSSPLITDATA;
    return this.baseService.Get<any>(this.config.createUrl(APIpath), mechanicForm);
  }
}
